export const container = `max-w-52 max-h-44 p-3 overflow-y-auto overflow-x-hidden`;
export const list = `flex flex-col gap-2`;
export const item = `border-b border-gray-150 last:border-b-0 text-sm text-base-black font-bold pb-2 last:pb-0`;
export const button = `inline-flex justify-between items-center h-5 w-full`;
export const itemText = `text-nowrap overflow-hidden text-ellipsis mr-2`;
export const icon = `text-gray-400 w-4 h-4 shrink-0 -mr-1`;
